import { useState } from 'react'
import { employeeName } from '../../utils/employee'
import { coloresAvatar } from '../../utils/avatarColor'

/**
 * Avatar circular de un empleado: su foto o, si no tiene (o no carga), sus
 * iniciales sobre un color derivado del nombre.
 *
 * @component
 * @param {Object} props
 * @param {Object|null} props.employee - Empleado (`nombre`, `apellido`, `photo`).
 * @param {number} [props.size=24] - Diámetro en píxeles.
 * @returns {JSX.Element}
 */
const UserAvatar = ({ employee, size = 24 }) => {
  const [broken, setBroken] = useState(false)
  const name = employeeName(employee)
  const initials =
    name
      .split(' ')
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase() || '?'
  // Tono estable por persona para distinguir iniciales de un vistazo; la
  // claridad del texto la calcula el util para que se lea con cualquier tono.
  const { color, background } = coloresAvatar(name)

  const style = { width: size, height: size, fontSize: size * 0.4 }

  return employee?.photo && !broken ? (
    <img
      src={employee.photo}
      alt={name}
      title={name}
      className="user-avatar"
      style={style}
      onError={() => setBroken(true)}
    />
  ) : (
    <span
      className="user-avatar is-initials"
      title={name || 'Sin datos'}
      style={{ ...style, color, background }}
    >
      {initials}
      <style>{`
        .user-avatar {
          flex-shrink: 0; border-radius: 50%; object-fit: cover;
          display: inline-flex; align-items: center; justify-content: center;
          font-weight: 700; line-height: 1;
        }
      `}</style>
    </span>
  )
}

export default UserAvatar
